'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var About = function (_Component) {
  (0, _inherits3.default)(About, _Component);

  function About() {
    (0, _classCallCheck3.default)(this, About);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(About).call(this));
  }

  (0, _createClass3.default)(About, [{
    key: 'render',
    value: function render() {
      var styles = require('./About.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.tactTitle },
          '艺品网'
        ),
        _react2.default.createElement('div', { className: styles.tactLink }),
        _react2.default.createElement(
          'div',
          { className: styles.tactTxt },
          '艺品网是中国工艺美术协会打造的工艺美术行业全产业链服务平台，通过整合行业优势资源，推动行业的转型升级，艺品网是工艺美术行业的互联网+转型服务平台。'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.tactTxt },
          '艺品网旨在弘扬中国手工艺文化，实现行业创新，分享互联网价值；通过“一品一码”和“真人、真品、真店”打造诚信保真体系，艺品网是工艺美术行业最具公信力的品牌。'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.tactTxt },
          '艺品网采用“O2O”模式，线上平台包括艺品交易、个性定制、行业服务、工美百科四大模块；线下采用“体验店”营销模式，让更多的消费者了解工艺品、喜欢工艺品，艺品网是工艺美术行业最具传播力的平台。'
        )
      );
    }
  }]);
  return About;
}(_react.Component); /**
                      * Created by zfc on 2016/9/13.
                      */


exports.default = About;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/About/About.js
 ** module id = 1435
 ** module chunks = 0
 **/